<template>
    <v-container>
        <v-row>
            <UserForm :userId="userId" :edit-mode="true"></UserForm>
        </v-row>
    </v-container>
</template>

<script>
    import UserForm from '../components/detail/user/UserForm';

    export default {
        name: "User",
        components: {
            UserForm
        },
        computed: {
            userId() {
                return this.$route.params.userId
            }
        }
    };
</script>
